import { Card, CardContent } from "@/components/ui/card";

// R16 N4 - where every call row went. The Calling headline counts HUMAN attempts only; the Employee Performance rows are the same population split by person. Everything the headline
// deliberately does not count (system / integration / customer log rows, "Didn't place the call", AI Voice channel rows) is listed here BY NAME with its count, so no call row disappears and
// the two tabs can be checked against each other. `reconciliation` is the backend's `call_reconciliation` block; absent (an old response / a caller filter) -> nothing is rendered.
export function CallReconciliation({ reconciliation }) {
  if (!reconciliation || !Array.isArray(reconciliation.partitions)) return null;
  const human = reconciliation.partitions.find((p) => p.key === "human_attempts");
  const others = reconciliation.partitions.filter((p) => p.key !== "human_attempts");
  return (
    <Card data-testid="call-reconciliation"><CardContent className="pt-4 space-y-2">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <p className="text-sm font-semibold">Where every call row went</p>
        <span className={`text-[11px] ${reconciliation.reconciles ? "text-muted-foreground" : "text-amber-700"}`} data-testid="call-reconciliation-status">
          {reconciliation.total_call_rows} call rows in this scope · {reconciliation.reconciles ? "every row accounted for" : "does NOT reconcile - report this"}
        </span>
      </div>
      {human && (
        <div className="flex justify-between text-sm border rounded px-2 py-1" data-testid="call-recon-human_attempts">
          <span>{human.label}</span>
          <span className="font-mono text-xs">
            {human.count} = {human.credited_to_employees} credited to employees + {human.actor_unavailable} actor unavailable
          </span>
        </div>
      )}
      {others.map((p) => (
        <div key={p.key} className="flex justify-between gap-3 text-sm border rounded px-2 py-1" data-testid={`call-recon-${p.key}`}>
          <span className="min-w-0">
            {p.label}
            {p.by_actor_type && Object.keys(p.by_actor_type).length > 0 && (
              <span className="block text-[11px] text-muted-foreground">
                {Object.entries(p.by_actor_type).map(([k, v]) => `${k.replace("legacy:", "legacy ")}: ${v}`).join(" · ")}
              </span>
            )}
          </span>
          <span className="font-mono text-xs shrink-0">{p.count}</span>
        </div>
      ))}
    </CardContent></Card>
  );
}
